/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Controls/Check': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M25.91 9.029l-1.17-.97a.257.257 0 00-.359.03L13.747 20.453 7.62 13.089a.258.258 0 00-.36-.03l-1.17.969a.247.247 0 00-.03.353l6.906 8.264a1.037 1.037 0 001.562 0L25.939 9.38a.246.246 0 00-.03-.352"/>'
  }
})
